<template>
  <div class="production-module">
    <!-- Header Section -->
    <div class="module-header">
      <div class="header-content">
        <div class="title-section">
          <div class="title-icon">
            <v-icon size="32" color="primary">mdi-factory</v-icon>
          </div>
          <h2 class="module-title">Líneas en Producción</h2>
        </div>
        
        <div class="controls-section">
          <div class="control-group">
            <s-select
              label="Seleccionar Turno"
              :items="itemTurn"
              item-value="TrnID"
              item-text="TnrObservation"
              v-model="processInitial.TrnID"
              @input="initialize()"
            />
          </div>
          
          <div class="control-group">
            <s-select-definition
              label="Seleccionar Cultivo"
              :def="1173"
              v-model="processInitial.TypeCultive"
              @change="initialize()"
            />
          </div>
          
          <div class="control-group toggle-group">
            <s-switch 
              label="Recordar Filtros" 
              v-model="recordateFilters"
              :true-value="1" 
              :false-value="0"
              color="primary"
              class="modern-switch"
            />
          </div>
          
          <!-- <div class="action-buttons" v-if="btnCut">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="action-btn cut-btn"
                  color="warning"
                  fab
                  elevation="4"
                  v-bind="attrs"
                  v-on="on"
                  @click="GenerateCutProcess()"
                >
                  <v-icon>mdi-content-cut</v-icon>
                </v-btn>
              </template>
              <span>Generar Corte</span>
            </v-tooltip>
          </div> -->
        </div>
      </div>
    </div>

    <!-- Warning Message -->
    <div v-if="Lines.length == 0 && itemsLineas.length == 0" class="warning-card">
      <div class="warning-content">
        <v-icon size="48" color="warning">mdi-alert-circle-outline</v-icon>
        <div class="warning-text">
          <h3>Configuración Requerida</h3>
          <p>Necesita crear líneas para acondicionamiento antes de continuar</p>
        </div>
      </div>
    </div>

    <!-- Main Content Card -->
    <div class="main-content-card" :class="{ 'loading': loading }">
      <div class="card-header">
        <h3 class="card-title">Control de Líneas</h3>
        <div class="card-actions">
          <v-btn
            v-if="showcard"
            :class="['toggle-btn', { 'active': showLinesProcess }]"
            :color="showLinesProcess ? 'error' : 'success'"
            fab
            small
            elevation="2"
            @click="getLineas()"
          >
            <v-icon>{{ showLinesProcess ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Lines Setup Section -->
      <div v-if="showLinesProcess && Lines.length > 0" class="lines-setup-section">
        <div class="setup-header">
          <h4>Configuración de Líneas</h4>
          <p>Seleccione las líneas que desea activar para el proceso</p>
        </div>
        
        <div class="lines-grid">
          <div v-for="(linea, i) in Lines" :key="i" class="line-item">
            <div class="line-card">
              <div class="line-info">
                <h5>{{ linea.LncDescription || 'Línea ' + (i + 1) }}</h5>
                <span class="line-code">ID: {{ linea.LncID || 'N/A' }}</span>
              </div>
              <div class="line-control">
                <s-switch
                  v-model="linea.LncProcessStarted"
                  :true-value="1"
                  :false-value="0"
                  color="primary"
                  class="line-switch"
                />
                <span class="switch-label">
                  {{ linea.LncProcessStarted ? 'Activa' : 'Inactiva' }}
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="setup-actions">
          <v-btn
            v-if="$fun.isAdmin() && Lines.length > 0"
            class="start-btn"
            color="success"
            large
            elevation="4"
            @click="initialProcess()"
          >
            <v-icon left>mdi-play</v-icon>
            Iniciar Proceso
          </v-btn>
        </div>
      </div>

      <!-- Production Lines Display -->
      <div v-if="itemsLineas.length > 0" class="production-lines-section">
        <div class="section-header">
           <v-btn @click="getHistoryVP()" dark small style="display: flex; gap: 5px; background-color: #007BFF; justify-content: center; align-items: center;">
              <v-icon dark >mdi-history</v-icon>
              <h5>Historial VP</h5>
           </v-btn>
          <div class="lines-count">
            <span class="count-badge">{{ linesProcessStarted.length }}</span>
            <span class="count-text">Líneas Activas</span>
          </div>
        </div>

        <div class="lines-container">
          <div
            class="grafLineMain"
            v-for="item in linesProcessStarted"
            :key="item.ClpID"
          >
            <!-- lista de lineas -->
            <c-lines-produc 
              :line="item"
              @close="closeLines($event)"
              @refreshlines="refreshlines()"
            />
          </div>
        </div>
      </div>
      
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay">
        <div class="loading-content">
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          />
          <p>Cargando líneas de producción...</p>
        </div>
      </div>
    </div>

    <!-- Dialogs -->
    <v-dialog
      persistent
      v-model="showLinesProcessDetail"
      transition="dialog-bottom-transition"
      width="80%"
      v-if="showLinesProcessDetail"
    >
      <v-card class="dialog-card">
        <showLinesProcessDetail @close="closeDialog()"/>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogGenerateCut"
      v-if="dialogGenerateCut"
      width="500"
    >
      <v-card class="dialog-card">
        <cut-process
          @CloseGenerateCutProcess="CloseGenerateCutProcess()"
          :tablesActiveTotal="tablesActiveTotal"
        />
      </v-card>
    </v-dialog>

    <!-- Diálogo Principal -->
    <v-dialog 
      v-model="dialogHistory" 
      max-width="1200px" 
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card class="elevation-12">
        <!-- Header del diálogo -->
        <v-card-title class="white--text" style="background: #007BFF;">
          <v-icon color="white" class="mr-3">mdi-factory</v-icon>
          <span class="text-h5 font-weight-bold">Historial de Proceso</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogHistory = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Chips indicadores -->
        <v-card-subtitle class="pb-0 pt-8">
          <div class="d-flex justify-center gap-4 mb-4">
            <v-chip 
              color="success" 
              outlined 
              pill
              class="px-4"
            >
              <v-icon left small>mdi-leaf</v-icon>
              Verde Proceso: {{ verdeProcesoCount }}
            </v-chip>
            <v-chip 
              color="red" 
              outlined 
              pill
              class="px-4"
            >
              <v-icon left small>mdi-delete-variant</v-icon>
              Corcho: {{ corchoCount }}
            </v-chip>
            <v-chip 
              color="primary" 
              outlined 
              pill
              class="px-4"
            >
              <v-icon left small>mdi-table</v-icon>
              Sin Observaciones: {{ sinObservacionesCount }}
            </v-chip>
            <v-chip 
              color="warning" 
              outlined 
              pill
              class="px-4"
            >
              <v-icon left small>mdi-table</v-icon>
              Total Mesas: {{ totalMesas }}
            </v-chip>
          </div>
        </v-card-subtitle>
        <v-card class="elevation-0 mx-4">
          <v-card-subtitle style="display: flex;">
            <v-icon color="primary" class="mr-2">mdi-filter-variant</v-icon>
            <h3 class="filter-title">Filtros de Búsqueda</h3>
          </v-card-subtitle>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-label style="color: #1A1A1A !important;">
                      <b>Linea</b>
                  </v-label>
                  <v-select
                    v-model="selectedLine"
                    :items="LncItems"
                    clearable
                    label=""
                    outlined
                    dense
                    hide-details
                  >
  
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-label style="color: #1A1A1A !important;">
                      <b>Mesa</b>
                  </v-label>
                  <v-select
                    v-model="selectedTable"
                    :items="CttItems"
                    clerarable
                    label=""
                    outlined
                    clearable
                    dense
                    hide-details
                  >
  
                  </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>

        <v-card-text>
          <!-- Pestañas para separar Verde Proceso y Corcho -->
          <v-tabs 
            v-model="activeTab" 
            background-color="transparent" 
            color="primary"
            grow
          >
            <v-tab class="font-weight-bold">
              <v-icon left color="success">mdi-leaf</v-icon>
              Verde Proceso
            </v-tab>
            <v-tab class="font-weight-bold">
              <v-icon left color="red">mdi-delete-variant</v-icon>
              Corcho (Descarte)
            </v-tab>
            <v-tab class="font-weight-bold">
              <v-icon left color="info">mdi-archive</v-icon>
              Sin Observaciones
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <!-- Pestaña Verde Proceso -->
            <v-tab-item>
              <v-card flat class="mt-4">
                <v-card-title class="pb-2">
                  <v-icon color="success" class="mr-2">mdi-leaf</v-icon>
                  <span class="text-h6">Registro Verde Proceso</span>
                  <v-spacer></v-spacer>
                  <!-- <v-text-field
                    v-model="searchVerdeProc"
                    append-icon="mdi-magnify"
                    label="Buscar..."
                    single-line
                    hide-details
                    dense
                    outlined
                    class="mt-0"
                    style="max-width: 300px;"
                  ></v-text-field> -->
                </v-card-title>

                <v-data-table
                  :headers="headers"
                  :items="verdeProcesoData"
                  :search="searchVerdeProc"
                  :loading="loading"
                  loading-text="Cargando datos..."
                  class="elevation-2"
                  :items-per-page="5"
                  :footer-props="{
                    'items-per-page-text': 'Filas por página:',
                    'items-per-page-options': [5, 10, 15, 20]
                  }"
                >
                  <template v-slot:item.LncDescription="{ item }">
                    <v-chip 
                      small 
                      color="success" 
                      dark
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-leaf</v-icon>
                      {{ item.LncDescription }}
                    </v-chip>
                  </template>

                  <template v-slot:item.DlpQuantity="{ item }">
                    <v-chip 
                      small 
                      color="orange" 
                      text-color="white"
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-package-variant</v-icon>
                      {{ item.DlpQuantity }} jabas
                    </v-chip>
                  </template>

                  <template v-slot:item.AverageWeightJabaN="{ item }">
                    <v-chip 
                      small 
                      color="blue-grey" 
                      text-color="white"
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-weight-kilogram</v-icon>
                      {{ item.AverageWeightJabaN | numberDefault }} kg
                    </v-chip>
                  </template>

                  <template v-slot:item.CttName="{ item }">
                    <v-chip 
                      small 
                      color="indigo" 
                      dark
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-table</v-icon>
                      {{ item.CttName }}
                    </v-chip>
                  </template>

                  <template v-slot:item.SecCreate="{ item }">
                    {{ $fun.formatDateView(item.SecCreate) }}
                  </template>

                  <template v-slot:no-data>
                    <div class="text-center py-8">
                      <v-icon size="64" color="grey lighten-1">mdi-database-off</v-icon>
                      <div class="text-h6 grey--text mt-2">No hay datos de Verde Proceso</div>
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>

            <!-- Pestaña Corcho -->
            <v-tab-item>
              <v-card flat class="mt-4">
                <v-card-title class="pb-2">
                  <v-icon color="red" class="mr-2">mdi-delete-variant</v-icon>
                  <span class="text-h6">Registro Corcho (Descarte)</span>
                  <v-spacer></v-spacer>
                  <!-- <v-text-field
                    v-model="searchCorcho"
                    append-icon="mdi-magnify"
                    label="Buscar..."
                    single-line
                    hide-details
                    dense
                    outlined
                    class="mt-0"
                    style="max-width: 300px;"
                  ></v-text-field> -->
                </v-card-title>

                <v-data-table
                  :headers="headers"
                  :items="corchoData"
                  :search="searchCorcho"
                  :loading="loading"
                  loading-text="Cargando datos..."
                  class="elevation-2"
                  :items-per-page="5"
                  :footer-props="{
                    'items-per-page-text': 'Filas por página:',
                    'items-per-page-options': [5, 10, 15, 20]
                  }"
                >
                  <template v-slot:item.LncDescription="{ item }">
                    <v-chip 
                      small 
                      color="red" 
                      dark
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-delete-variant</v-icon>
                      {{ item.LncDescription }}
                    </v-chip>
                  </template>

                  <template v-slot:item.DlpQuantity="{ item }">
                    <v-chip 
                      small 
                      color="orange" 
                      text-color="white"
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-package-variant</v-icon>
                      {{ item.DlpQuantity }} jabas
                    </v-chip>
                  </template>

                  <template v-slot:item.AverageWeightJabaN="{ item }">
                    <v-chip 
                      small 
                      color="blue-grey" 
                      text-color="white"
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-weight-kilogram</v-icon>
                      {{ item.AverageWeightJabaN | numberDefault }} kg
                    </v-chip>
                  </template>

                  <template v-slot:item.CttName="{ item }">
                    <v-chip 
                      small 
                      color="indigo" 
                      dark
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-table</v-icon>
                      {{ item.CttName }}
                    </v-chip>
                  </template>

                  <template v-slot:item.SecCreate="{ item }">
                    {{ $fun.formatDateView(item.SecCreate) }}
                  </template>

                  <template v-slot:no-data>
                    <div class="text-center py-8">
                      <v-icon size="64" color="grey lighten-1">mdi-database-off</v-icon>
                      <div class="text-h6 grey--text mt-2">No hay datos de Corcho (Descarte)</div>
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>

            <!-- Pestaña sin Observaciones -->
            <v-tab-item>
              <v-card flat class="mt-4">
                <v-card-title class="pb-2">
                  <v-icon color="info" class="mr-2">mdi-archive</v-icon>
                  <span class="text-h6">Sin Observaciones</span>
                  <v-spacer></v-spacer>
                </v-card-title>

                <v-data-table
                  :headers="headers"
                  :items="sinObservacionesData"
                  :search="searchCorcho"
                  :loading="loading"
                  loading-text="Cargando datos..."
                  class="elevation-2"
                  :items-per-page="5"
                  :footer-props="{
                    'items-per-page-text': 'Filas por página:',
                    'items-per-page-options': [5, 10, 15, 20]
                  }"
                >
                  <template v-slot:item.LncDescription="{ item }">
                    <v-chip 
                      small 
                      color="red" 
                      dark
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-archive</v-icon>
                      {{ item.LncDescription }}
                    </v-chip>
                  </template>

                  <template v-slot:item.DlpQuantity="{ item }">
                    <v-chip 
                      small 
                      color="orange" 
                      text-color="white"
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-package-variant</v-icon>
                      {{ item.DlpQuantity }} jabas
                    </v-chip>
                  </template>

                  <template v-slot:item.AverageWeightJabaN="{ item }">
                    <v-chip 
                      small 
                      color="blue-grey" 
                      text-color="white"
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-weight-kilogram</v-icon>
                      {{ item.AverageWeightJabaN | numberDefault }} kg
                    </v-chip>
                  </template>

                  <template v-slot:item.CttName="{ item }">
                    <v-chip 
                      small 
                      color="indigo" 
                      dark
                      class="font-weight-bold"
                    >
                      <v-icon left x-small>mdi-table</v-icon>
                      {{ item.CttName }}
                    </v-chip>
                  </template>

                  <template v-slot:item.SecCreate="{ item }">
                    {{ $fun.formatDateView(item.SecCreate) }}
                  </template>

                  <template v-slot:no-data>
                    <div class="text-center py-8">
                      <v-icon size="64" color="grey lighten-1">mdi-database-off</v-icon>
                      <div class="text-h6 grey--text mt-2">No hay datos de Sin Observaciones</div>
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <!-- Footer con estadísticas -->
        <v-card-actions class="pa-4" style="background-color: #f5f5f5;">
          <v-row>
            <v-col cols="12" md="3">
              <v-card outlined class="pa-3 text-center">
                <v-icon color="success" size="24">mdi-leaf</v-icon>
                <div class="text-h6 font-weight-bold success--text">
                  {{ totalJabasVerdeProc }} jabas - {{ totalVerdeProc | numberDefault }} kg
                </div>
                <div class="caption">Total Verde Proceso</div>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card outlined class="pa-3 text-center">
                <v-icon color="red" size="24">mdi-delete-variant</v-icon>
                <div class="text-h6 font-weight-bold red--text">
                  {{ totalJabasCorcho }} jabas - {{ totalCorcho | numberDefault }} kg
                </div>
                <div class="caption">Total Corcho (Descarte)</div>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card outlined class="pa-3 text-center">
                <v-icon color="info" size="24">mdi-archive</v-icon>
                <div class="text-h6 font-weight-bold info--text">
                  {{ totalJabasSinObservaciones }} jabas - {{ totalSinObservaciones | numberDefault }} kg
                </div>
                <div class="caption">Total Sin Observaciones</div>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card outlined class="pa-3 text-center">
                <v-icon color="warning" size="24">mdi-scale-balance</v-icon>
                <div class="text-h6 font-weight-bold warning--text">
                  {{ totalJabasGeneral }} jabas - {{ totalGeneral | numberDefault }} kg
                </div>
                <div class="caption">Total General</div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sTurnService from "../../../services/FreshProduction/PrfTurnService";
import showLinesProcessDetail from "./showLinesProcessDetail.vue";
import _sFrzCtnLinesProcessService from "@/services/FrozenProduction/FrzCtnLinesProcess.js"
import _sProductionLine from "@/services/FrozenProduction/ProductionLine.js"
import cLinesProduc from "./CLinesProduc.vue"
import CutProcess from './CutProcess.vue';

export default {
  components: { showLinesProcessDetail, cLinesProduc, CutProcess },
  prop: {},
  data: () => ({
    selectedLine: null,
    selectedTable: null,
    recordateFilters: 0,
    loading: false,
    itemTurn: [],
    showLinesProcessDetail: false,
    itemsLineas: [],
    modelDialog: false,
    processInitial: {
      TrnID: null,
      TypeCultive: null
    },
    btnInitial: false,
    btnCut: false,
    dialogGenerateCut: false,
    tablesActiveTotal: [],
    showcard: false,
    Lines: [],
    SelectLinea: [],
    showLinesProcess: false,

    dialogHistory: false,
    loading: false,
    activeTab: 0,
    searchVerdeProc: '',
    searchCorcho: '',
    historyData: [], // Aquí almacenarás tu array completo
    
    // Headers para las tablas
    headers: [
      { 
        text: 'Linea', 
        value: 'LncDescription', 
        sortable: false,
        width: '120px'
      },
      { 
        text: 'Mesa', 
        value: 'CttName', 
        align: 'center',
        width: '100px'
      },
      { 
        text: 'Cantidad Jabas', 
        value: 'DlpQuantity', 
        align: 'center',
        width: '120px'
      },
      { 
        text: 'Peso (kg)', 
        value: 'AverageWeightJabaN', 
        align: 'center',
        width: '120px'
      },
      { 
        text: 'Cortador', 
        value: 'UsrCutterName', 
        sortable: false
      },
      { 
        text: 'Usuario', 
        value: 'UsrCreateName',
        sortable: false
      },
    ]
  }),
  watch: {
    recordateFilters(val) {
      localStorage.setItem("recordateFilters", val);
      if (val == 1) {
        localStorage.setItem("processInitial", JSON.stringify(this.processInitial));
      } else {
        localStorage.removeItem("processInitial");
      }
      localStorage.setItem("processInitialData", JSON.stringify(this.processInitial));
    },
    processInitial: {
      handler(val) {
        if (!val || !val.TypeCultive || !val.TrnID) return;
        const data = {
          TypeCultive: val.TypeCultive,
          TrnID: val.TrnID
        };
        if (this.recordateFilters == 1) {
          localStorage.setItem("processInitial", JSON.stringify(data));
        }
        console.log("Se esta ejecutando el wach", data);
        localStorage.setItem("processInitialData", JSON.stringify(data));
      },
      deep: true
    },
  },
  methods: {
    async getHistoryVP() {
      this.loading = true
      this.dialogHistory = true
      
      try {
        // Aquí haces tu llamada a la API para obtener los datos
        // const response = await this.$axios.get('/api/history-vp')
        // this.historyData = response.data
        
        // Datos de ejemplo para testing
        // this.historyData = [
        //   { 
        //     DlpTypeDiscard: 1, 
        //     CttID: 'A001', 
        //     DlpQuantity: 15, 
        //     AverageWeightJabaN: 25.5,
        //     SecCreate: '2024-01-15',
        //     UsrCreateName: 'Mango verde proceso mesa A001'
        //   },
        //   { 
        //     DlpTypeDiscard: 2, 
        //     CttID: 'B002', 
        //     DlpQuantity: 8, 
        //     AverageWeightJabaN: 18.2,
        //     SecCreate: '2024-01-15',
        //     UsrCreateName: 'Palta descarte (corcho) mesa B002'
        //   },
        //   { 
        //     DlpTypeDiscard: 1, 
        //     CttID: 'C003', 
        //     DlpQuantity: 20, 
        //     AverageWeightJabaN: 32.1,
        //     SecCreate: '2024-01-16',
        //     UsrCreateName: 'Mango verde proceso mesa C003'
        //   },
        //   { 
        //     DlpTypeDiscard: 2, 
        //     CttID: 'A001', 
        //     DlpQuantity: 6, 
        //     AverageWeightJabaN: 12.8,
        //     SecCreate: '2024-01-16',
        //     UsrCreateName: 'Palta descarte (corcho) mesa A001'
        //   }
        // ]

        _sFrzCtnLinesProcessService.FrzDollTableVP_List({TrnID: this.processInitial.TrnID},this.$fun.getUserID()).then(r => {
          if (r.status == 200) {
            console.log('r.data', r.data);
            this.historyData = r.data
          }
        })
        
      } catch (error) {
        console.error('Error al cargar historial:', error)
        this.$toast.error('Error al cargar el historial')
      } finally {
        this.loading = false
      }
    },
    getDataFilters() {
      const recordateFilters = localStorage.getItem('recordateFilters');
      this.recordateFilters = recordateFilters == '1' ? 1 : 0;
      if (this.recordateFilters == 1) {
        const processInitial = localStorage.getItem('processInitial');
        this.processInitial = processInitial ? JSON.parse(processInitial) : { TrnID: null, TypeCultive: null };
      }
    },
    GenerateCutProcess() {
      this.tablesActiveTotal = [];
      this.itemsLineas.forEach(element => {
        let ClpID = element.ClpID;
        _sFrzCtnLinesProcessService
          .listTablesByLines({ ClpID }, this.$fun.getUserID())
          .then(r => {
            if (r.status == 200) {
              this.tablesActiveTotal.push(...r.data);
            }
          })
      })
      this.dialogGenerateCut = true;
    },
    CloseGenerateCutProcess() {
      this.dialogGenerateCut = false;
      this.initialize();
    },
    refreshlines() {
      this.itemsLineas = [];
      this.initialize();
    },
    async initialProcess() {
      this.$fun.alert("¿Está seguro de iniciar el proceso?", "question").then(async (r) => {
        if (r.value) {
          if (this.processInitial.TrnID == null || this.processInitial.TypeCultive == null) {
            return;
          }
          if (this.Lines.length > 0) {
            this.processInitial.ProductionLines = this.Lines;
            // Persistir el estado LncProcessStarted de cada linea y esperar a que terminen
            const saves = this.Lines.map(linea =>
              _sProductionLine.save({
                LncID: linea.LncID,
                CecID: linea.CecID,
                LncDescription: linea.LncDescription,
                typeCultive: linea.TypeCultive,
                SecStatus: linea.SecStatus,
                UsrCreateID: linea.UsrCreateID,
                UsrUpdateID: this.$fun.getUserID(),
                LncState: linea.LncState,
                LncProcessStarted: linea.LncProcessStarted
              }, this.$fun.getUserID()).catch(() => null)
            );
            await Promise.all(saves);
          }
          this.processInitial.UsrCreateID = this.$fun.getUserID();
          _sFrzCtnLinesProcessService.initial(this.processInitial, this.$fun.getUserID())
            .then((r) => {
              if (r.status == 200) {
                this.initialize();
              }
            })
        }
      });
    },
    closeLines(line) {
      this.initialize();
    },
    openDialog(item) {
      this.items = item;
      this.modelDialog = true;
    },
    closeDialog() {
      this.showLinesProcessDetail = false;
      this.modelDialog = false;
      this.initialize();
    },
    openLinesProcessDetail() {
      this.showLinesProcessDetail = true;
    },
    initialize() {
      this.showLinesProcess = false;
      this.itemsLineas = [];
      if (this.processInitial.TrnID == null || this.processInitial.TypeCultive == null) {
        return;
      }
      let ntpId = this.$fun.isAdmin() ? null : this.$fun.getUserInfo().NtpID;
      this.loading = true;
      this.processInitial.NtpID = ntpId;
      _sFrzCtnLinesProcessService.listLineas(this.processInitial, this.$fun.getUserID()).then(r => {
        if (r.status == 200) {
          this.itemsLineas = r.data
          if (this.itemsLineas.length == 0) {
            this.btnInitial = true;
            this.btnCut = false;
            this.showcard = false;
            this.showLinesProcess = false;
            this.getLineas();
          } else if (this.itemsLineas.length > 0) {
            this.Lines = [];
            this.btnCut = true;
            this.btnInitial = false;
            this.showcard = true;
          }
          this.loading = false;
        }
      })
    },
    TurnActive() {
      let TypeArea = 4
      _sTurnService.turnActive({ TypeArea: TypeArea }, this.$fun.getUserID()).then(r => {
        if (r.status == 200) {
          this.itemTurn = r.data;
        }
      });
    },
    ClickRefreshLines() {
      this.initialize();
    },
    getLineas() {
      this.showLinesProcess = !this.showLinesProcess;
      if (this.showLinesProcess) {
        _sFrzCtnLinesProcessService.getLineasCreated(this.processInitial, this.$fun.getUserID()).then(r => {
          if (r.status == 200) {
            this.Lines = r.data;
            console.log(this.Lines, "lineas");
          }
        });
      }
    }
  },
  created() {
    this.initialize();
    this.TurnActive();
    this.getDataFilters();
  },
  computed: {
    linesProcessStarted() {
      return this.itemsLineas.filter(item => item.LncProcessStarted == 1);
    },
    LncItems() {
      const unique = new Map();
      this.historyData.forEach(item => {
        if (item.LncID && !unique.has(item.LncID)) {
          unique.set(item.LncID, {
            value: item.LncID,
            text: item.LncDescription
          });
        }
      });
      return Array.from(unique.values());
    },

    CttItems() {
      const unique = new Map();
      this.historyData.forEach(item => {
        if (item.CttID && !unique.has(item.CttID)) {
          unique.set(item.CttID, {
            value: item.CttID,
            text: item.CttName
          });
        }
      });
      return Array.from(unique.values());
    },
    // Filtrar datos por tipo
    verdeProcesoData() {
      return this.historyData.filter(item =>
        item.DlpTypeDiscard == 1 &&
        (!this.selectedLine || item.LncID === this.selectedLine) &&
        (!this.selectedTable || item.CttID === this.selectedTable)
      );
    },

    corchoData() {
      return this.historyData.filter(item =>
        item.DlpTypeDiscard == 2 &&
        (!this.selectedLine || item.LncID === this.selectedLine) &&
        (!this.selectedTable || item.CttID === this.selectedTable)
      );
    },
    
    sinObservacionesData() {
      return this.historyData.filter(item =>
        item.DlpTypeDiscard == 3 &&
        (!this.selectedLine || item.LncID === this.selectedLine) &&
        (!this.selectedTable || item.CttID === this.selectedTable)
      );
    },
    
    // Contadores
    verdeProcesoCount() {
      return this.verdeProcesoData.length
    },
    
    corchoCount() {
      return this.corchoData.length
    },

    sinObservacionesCount() {
      return this.sinObservacionesData.length
    },
    
    // Mesas únicas
    totalMesas() {
      const mesas = [...new Set(this.historyData.map(item => item.CttID))]
      return mesas.length
    },
    
    // Totales de jabas
    totalJabasVerdeProc() {
      return this.verdeProcesoData.reduce((sum, item) => sum + (item.DlpQuantity || 0), 0)
    },
    
    totalJabasCorcho() {
      return this.corchoData.reduce((sum, item) => sum + (item.DlpQuantity || 0), 0)
    },

    totalJabasSinObservaciones() {
      return this.sinObservacionesData.reduce((sum, item) => sum + (item.DlpQuantity || 0), 0)
    },
    
    totalJabasGeneral() {
      return this.totalJabasVerdeProc + this.totalJabasCorcho + this.totalJabasSinObservaciones
    },
    
    // Totales de peso (no cantidad de jabas)
    totalVerdeProc() {
      return this.verdeProcesoData.reduce((sum, item) => sum + (item.AverageWeightJabaN || 0), 0)
    },
    
    totalCorcho() {
      return this.corchoData.reduce((sum, item) => sum + (item.AverageWeightJabaN || 0), 0)
    },

    totalSinObservaciones() {
      return this.sinObservacionesData.reduce((sum, item) => sum + (item.AverageWeightJabaN || 0), 0)
    },
    
    totalGeneral() {
      return this.totalVerdeProc + this.totalCorcho + this.totalSinObservaciones
    }
  },
};
</script>

<style scoped>
.production-module {
  padding: 10px;
  /* background: linear-gradient(135deg, #1976D215, #42A5F515); */
  min-height: 100vh;
  border-radius: 10px;
}

/* Header Styles */
.module-header {
  /* background: #007BFF; */
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 16px;
  color: white;
}

.title-icon {
  background: rgb(255, 255, 255);
  padding: 12px;
  border-radius: 50%;
  backdrop-filter: blur(10px);
}

.module-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.15);
  padding: 8px 16px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4caf50;
  animation: pulse 2s infinite;
}

.status-dot.active {
  background: #4caf50;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.status-text {
  font-size: 14px;
  font-weight: 500;
}

.controls-section {
  display: flex;
  align-items: end;
  gap: 20px;
  flex-wrap: wrap;
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 200px;
}

.toggle-group {
  min-width: auto;
}

.modern-switch {
  margin-top: 8px;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.action-btn {
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-2px);
}

.cut-btn {
  background: linear-gradient(135deg, #ff7043 0%, #ff5722 100%);
}

/* Warning Card */
.warning-card {
  background: linear-gradient(135deg, #fff3e0 0%, #ffcc80 100%);
  border: 1px solid #ff9800;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(255, 152, 0, 0.1);
}

.warning-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.warning-text h3 {
  margin: 0 0 8px 0;
  color: #e65100;
  font-size: 20px;
}

.warning-text p {
  margin: 0;
  color: #ef6c00;
  font-size: 16px;
}

/* Main Content Card */
.main-content-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  position: relative;
  min-height: 300px;
}

.card-header {
  /* background: #007BFF; */
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  padding: 20px 24px;
  /* border-bottom: 1px solid #e3f2fd; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.toggle-btn {
  transition: all 0.3s ease;
}

.toggle-btn:hover {
  transform: scale(1.05);
}

.toggle-btn.active {
  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%);
}

/* Lines Setup Section */
.lines-setup-section {
  padding: 24px;
  border-bottom: 1px solid #e0e0e0;
}

.setup-header {
  margin-bottom: 20px;
  text-align: center;
}

.setup-header h4 {
  color: #007BFF;
  font-size: 18px;
  margin: 0 0 8px 0;
}

.setup-header p {
  color: #666;
  margin: 0;
}

.lines-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.line-item {
  background: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
}

.line-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  transition: all 0.3s ease;
}

.line-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.line-info h5 {
  margin: 0 0 4px 0;
  color: #333;
  font-size: 16px;
}

.line-code {
  color: #666;
  font-size: 12px;
}

.line-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.switch-label {
  font-size: 12px;
  color: #666;
}

.setup-actions {
  display: flex;
  justify-content: center;
}

.start-btn {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  color: white;
  font-weight: 600;
  padding: 12px 24px;
  transition: all 0.3s ease;
}

.start-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(76, 175, 80, 0.3);
}

/* Production Lines Section */
.production-lines-section {
  padding: 24px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-header h4 {
  color: #1565c0;
  font-size: 18px;
  margin: 0;
}

.lines-count {
  display: flex;
  align-items: center;
  gap: 8px;
}

.count-badge {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 14px;
}

.count-text {
  color: #666;
  font-size: 14px;
}

.lines-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
}

/* Mantener el estilo original de grafLineMain */
.grafLineMain {
  display: flex;
  align-items: stretch;
  position: relative;
  float: none;
  text-align: center;
  justify-content: center;
  border-style: dotted;
  border-color: white;
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  transition: all 0.3s ease;
}

/* .grafLineMain:hover {
  transform: translateY(-4px);
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
} */

/* Loading Overlay */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-content {
  text-align: center;
}

.loading-content p {
  margin-top: 16px;
  color: #666;
  font-size: 16px;
}

/* Dialog Styles */
.dialog-card {
  border-radius: 16px;
  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.2);
}

/* Responsive Design */
@media (max-width: 768px) {
  .production-module {
    padding: 16px;
  }
  
  .header-content {
    flex-direction: column;
    align-items: stretch;
  }
  
  .controls-section {
    justify-content: center;
  }
  
  .control-group {
    min-width: 100%;
  }
  
  .lines-container {
    grid-template-columns: 1fr;
  }
  
  .lines-grid {
    grid-template-columns: 1fr;
  }
}



.gap-4 {
  gap: 1rem;
}

/* Animaciones suaves para las pestañas */
.v-tabs-items {
  transition: all 0.3s ease;
}

/* Estilos para mejorar la apariencia */
.v-data-table >>> .v-data-table__wrapper {
  border-radius: 8px;
}

.v-chip {
  transition: all 0.2s ease;
}

.v-chip:hover {
  transform: scale(1.05);
}

/* Gradiente para el header */
.v-card-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

::v-deep(.v-text-field.v-text-field--enclosed){
  background: #FFF;
}

::v-deep(.v-label){
  color: #ffffff !important;
}
</style>